export default __webpack_public_path__ + "static/media/480_store05-jp-web.da0217ba.png";